import { BrandRFMProfile } from "../models/brandRFMProfile";
import { BrandRFMSetting } from "../models/brandRFMSetting";
import { CompletedCampaignViewModel } from "../models/campaign";

export function prepareRFMSettings(
  activeProfile: BrandRFMProfile | undefined,
  brandId: string,
  selectedPeriod: any,
  applyFrequencyDataUpdate: (
    oldData: BrandRFMSetting[],
    newData: BrandRFMSetting[],
    selectedPeriod: any
  ) => {
    updatedSettings: BrandRFMSetting[];
    transformedData: BrandRFMSetting[];
  }
) {
  const data = Array.isArray(activeProfile?.BrandRFMProfileSetting)
    ? activeProfile!.BrandRFMProfileSetting
    : [];

  const sortedData = [...data].sort(
    (a, b) => (b.RFMTier || 0) - (a.RFMTier || 0)
  );

  const mappedData: BrandRFMSetting[] = sortedData.map((item) => ({
    ...item,
    BrandId: brandId,
  }));

  let newRFMSettings: BrandRFMSetting[] = [];
  let transformedData: BrandRFMSetting[] = [];

  if (mappedData.length > 0) {
    const result = applyFrequencyDataUpdate(
      mappedData,
      mappedData,
      selectedPeriod
    );
    newRFMSettings = result.updatedSettings;
    transformedData = result.transformedData;
  }

  return {
    mappedData,
    newRFMSettings,
    transformedData,
  };
}

export const calculateCampaignStats = (data: CompletedCampaignViewModel[]) => {
  const toNum = (val: any): number => {
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  };

  const sum = (
    selector: (x: CompletedCampaignViewModel) => number | string | undefined
  ) => data.reduce((s, x) => s + toNum(selector(x)), 0);

  const avg = (
    selector: (x: CompletedCampaignViewModel) => number | string | undefined
  ) => (data.length > 0 ? sum(selector) / data.length : 0);

  return {
    totalRevenueRewards: sum((x) => x.RevenueRewards),
    totalOrderRewards: sum((x) => x.TotalOrderRewards),

    totalRevenueCampaign: sum((x) => x.RevenueCampaign),
    totalOrderCampaign: sum((x) => x.TotalOrderCampaign),

    avgROI: avg((x) => x.ROI),
    avgCTR: avg((x) => x.CTR),
  };
};
export function prepareActiveRFMProfile(
  activeProfile: BrandRFMProfile,
  defaultProfile: BrandRFMProfile[],
  brandId: string,
  selectedPeriod: any,
  applyFrequencyDataUpdate: (
    oldData: BrandRFMSetting[],
    newData: BrandRFMSetting[],
    selectedPeriod: any
  ) => {
    updatedSettings: BrandRFMSetting[];
    transformedData: BrandRFMSetting[];
  }
) {
  let finalProfile = { ...activeProfile };
  if (finalProfile.IsAuto) {
    const matchedDefault = defaultProfile.find(
      (p) => p.Name === finalProfile.Name
    );

    const fallbackDefault =
      finalProfile.Name === "Full Service Default Profiles"
        ? defaultProfile.find((p) => p.Name === "Full Service Default Profiles")
        : defaultProfile.find(
            (p) => p.Name === "Quick Service Default Profiles"
          );

    const defaultToUse = matchedDefault || fallbackDefault;

    if (defaultToUse?.BrandRFMProfileSetting) {
      finalProfile = {
        ...finalProfile,
        BrandRFMProfileSetting: [
          ...defaultToUse.BrandRFMProfileSetting.map((x: any) => ({ ...x })),
        ],
      };
    }
  }

  const { mappedData, newRFMSettings, transformedData } = prepareRFMSettings(
    finalProfile,
    brandId,
    selectedPeriod,
    applyFrequencyDataUpdate
  );

  return {
    finalProfile,
    mappedData,
    newRFMSettings,
    transformedData,
  };
}
